// extracted by mini-css-extract-plugin
export default {"nonAuthContainer":"TermsOfUse_nonAuthContainer__S18rY","termsBox":"TermsOfUse_termsBox__4ntui","tosText":"TermsOfUse_tosText__kPHb1","tosButton":"TermsOfUse_tosButton__SmKLW"};